import { KYMW9000Model } from '../kymw9000.model';
import { KYMW9000InputVO } from '../vo/kymw9000-input.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';
import { PlessViewUtilsSub } from 'src/app/commons/kymw00/pless-view-utils-sub.service';

/**
 * 関連会社ユーザ一覧を取得する
 *
 * @export API通信成功時の処理
 * @class GetAssociatedUserManagementListService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class GetAssociatedUserManagementListService extends PlessJsonResponderSub<any> {

  // 処理に使用するModel
  private model: KYMW9000Model;
  private successFunc: Function;
  private vo: KYMW9000InputVO;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetAssociatedUserManagementList
   */
  private getBody(): PlessRequest {
    let condition: any = {};

    // ユーザ区分に空欄以外が設定されている場合、ユーザ区分をリクエストパラメータに含める
    if (!PlessViewUtilsSub.isEmpty(this.vo.associatedUserType)) {
      condition["AssociatedUserType"] = this.vo.associatedUserType;
    }
    // 氏名に空欄以外が設定されている場合、氏名をリクエストパラメータに含める
    if (!PlessViewUtilsSub.isEmpty(this.vo.associatedUserName)) {
      condition["AssociatedUserName"] = this.vo.associatedUserName;
    }
    // メールアドレスに空欄以外が設定されている場合、メールアドレスをリクエストパラメータに含める
    if (!PlessViewUtilsSub.isEmpty(this.vo.emailAddress)) {
      condition["EmailAddress"] = this.vo.emailAddress;
    }
    // 権限に空欄以外が設定されている場合、権限をリクエストパラメータに含める
    if (!PlessViewUtilsSub.isEmpty(this.vo.authoritySetId)) {
      condition["AuthoritySetId"] = this.vo.authoritySetId;
    }
    // 所属に空欄以外が設定されている場合、所属をリクエストパラメータに含める
    if (!PlessViewUtilsSub.isEmpty(this.vo.associatedCompanyName)) {
      condition["AssociatedCompanyName"] = this.vo.associatedCompanyName;
    }
    condition["IsEnabled"] = this.vo.isEnabled;
    condition["Page"] = this.vo.page;

    return new PlessRequest({
      search : {
        AssociatedUserList: {
          condition,
        }
      }
    })
  }

  /**
   * API呼び出し
   *
   * @param {KYMW9000Model} model
   * @param {any} vo
   * @param {Function} [successFunc=null] 成功時後続処理
   * @memberof GetAssociatedUserManagementList
   */
  execute(model: KYMW9000Model, vo: KYMW9000InputVO, successFunc: Function = null) {
    this.model = model;
    this.vo = vo;
    this.successFunc = successFunc;
    this.send('getAssociatedUserManagementList', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetAssociatedUserManagementList
   */
  success(data: any) {
    this.model.updateAssociatedUserManagementList(data);
    this.model.kymw9000Component.searchFlag = true;
    if( this.successFunc !== null ) {
      this.successFunc(data);
    }
  }

}
